<template>
  <div class="alert d-inline-flex" :class="`alert-${type}`" role="alert" v-if="messages.length">
    <span v-for="(message, index) in messages" v-text="message" :key="index"></span>
  </div>
</template>

<script>
export default {
  name: 'Alert',
  props: ['type', 'messages'],
};
</script>
